import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import { notesModal } from './state/notes.reducers';
import { NOTES_MODAL_SLICE_KEY } from './state/notes.constants';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { ConfirmModalModule } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.module';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import { SharingModalModule } from 'NewAngular/features/components/modals/sharing-modal/sharing-modal.module';
import { DisabledModule } from 'NewAngular/features/directives/disabled/disabled.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import { SecurityListSelectorModalModule } from 'SecurityListsApp/ts/features/security-list-selector-modals/security-list-selector-modal.module';
import { IsSharedWithOthersPipeModule } from 'SharingApp/ts/pipes/is-shared-with-others-pipe.module';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class NotesAppModule {
}
NotesAppModule.ɵfac = function NotesAppModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NotesAppModule)(); };
NotesAppModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: NotesAppModule });
NotesAppModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        ConfirmModalModule,
        DisabledModule,
        FeatureNeededModule,
        FormsModule,
        IconModule,
        IsSharedWithOthersPipeModule,
        ModalBaseModule,
        SharingModalModule,
        StoreModule.forFeature(NOTES_MODAL_SLICE_KEY, notesModal),
        SecurityListSelectorModalModule,
        TooltipModule] });
